import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IRegisterForm } from '../register-form/register-form.component';
import { AuthService, IGetPageRegistrationConfigurationResponseModel, IMemberFieldCustomQuestionAnswerLang, IMemberFieldCustomQuestionLang, IRegistrationCompletionRequest } from '../../services/auth.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from 'src/app/shared/services/alert.service';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
//import { ThrowStmt } from '@angular/compiler';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { AccountService, IAddExistingCardForm } from 'src/app/account/services/account.service';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { AddressEditorModalComponent } from 'src/app/shared/components/address-editor-modal/address-editor-modal.component';
import { ModalController } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ILocation } from 'src/app/services/location.service';
import { IAddress } from 'src/app/shared/services/address.service';

export interface ICompleteRegistrationForm {

}

interface FieldMapEntry {
  api: string;
  form: string;
  email?: boolean;
  requiredWhen: number[];
  isBool: boolean;
}

interface ICustomQuestions {
  id: number;
  mandatory: number;
  pageId?: number;
  questionTranslation: ITranslatableText;
  customQuestionDataLang: IMemberFieldCustomQuestionLang[];

  customAnswersToQuestion: ICustomAnswersQuestions[]; // where you can collect the data and ids
}

interface ICustomAnswersQuestions {
  id: number;
  ConnectedQuestionId: number;
  answers: ITranslatableText;
  answerOriginalData: IMemberFieldCustomQuestionAnswerLang[]; // where you can collect the data and ids
}

@Component({
    selector: 'auth-confirm-registration-form',
    templateUrl: './confirm-registration-form.component.html',
    styleUrls: ['./confirm-registration-form.component.scss'],
    standalone: false
})
export class ConfirmRegistrationFormComponent implements OnInit {
  form: FormGroup;
  customForm: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  patternReference: any = {};

  private _emailCode: IRegisterForm;
  

  @Input()
  set emailCode(value: IRegisterForm) {
    this._emailCode = value;
  }

  get emailCode() {
    return this._emailCode;
  }

  get email() {
    if (this.emailCode)
      return this.emailCode.email;

    return '';
  }

  @Output()
  onSubmit: EventEmitter<ICompleteRegistrationForm> = new EventEmitter<ICompleteRegistrationForm>();

  _CustomRegData: IGetPageRegistrationConfigurationResponseModel;
  @Input() set customRegistration(value: IGetPageRegistrationConfigurationResponseModel) {
    this._CustomRegData = value;
  }

  _useCustomAPI: boolean = false;
  @Input() set useCustomAPI(value: boolean) {
    this._useCustomAPI = value;
  }

  _locations: ILocation[] = [];
  @Input() set locations(value: ILocation[]) {
    this._locations = value;
  }

  // setup the api values here
  private readonly fieldMap: readonly FieldMapEntry[] = [
    { api: 'first_name', form: 'firstName', email: false, requiredWhen: [2], isBool: false },
    { api: 'last_name', form: 'lastName', email: false, requiredWhen: [2], isBool: false },
    { api: 'email', form: 'email', email: true, requiredWhen: [2], isBool: false },
    //{ api: 'mobile', form: 'mobile', email: false, requiredWhen: [2], isBool: false },                   // in the request api but not used right now
    { api: 'phone', form: 'phone', email: false, requiredWhen: [2], isBool: false },
    //{ api: 'company_phone', form: 'companyPhone', email: false, requiredWhen: [2], isBool: false },
    //{ api: 'company_title', form: 'companyTitle', email: false, requiredWhen: [2], isBool: false },
    { api: 'card_number', form: 'cardNumber', email: false, requiredWhen: [2], isBool: false },
    { api: 'digital_card', form: 'digitalCard', email: false, requiredWhen: [2], isBool: true },
    { api: 'gender', form: 'gender', email: false, requiredWhen: [2], isBool: false },
    //{ api: 'mobile_carrier', form: 'mobileCarrier', email: false, requiredWhen: [2], isBool: false },    // in the request api but not used right now
    //{ api: 'question_1', form: 'question1', email: false, requiredWhen: [2], isBool: false },            // in the request api but not used right now
    //{ api: 'question_2', form: 'question2', email: false, requiredWhen: [2], isBool: false },            // in the request api but not used right now
    
    { api: 'ask_favorite_store', form: 'favoriteStore', email: false, requiredWhen: [2], isBool: false },

    { api: 'address', form: 'streetNumber', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'suffix', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'street', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'streetType', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'streetDirection', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'suiteNumber', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'city', email: false, requiredWhen: [2], isBool: false },
    { api: 'address', form: 'postalCode', email: false, requiredWhen: [2, 3], isBool: false },
    { api: 'address', form: 'province', email: false, requiredWhen: [2, 3], isBool: false },
    { api: 'address', form: 'country', email: false, requiredWhen: [2, 3], isBool: false },

    /*    // in the request api but not used right now
    { api: 'company_address', form: 'companyStreetNumber', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companySuffix', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companyStreet', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companyStreetType', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companyStreetDirection', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companySuiteNumber', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companyCity', email: false, requiredWhen: [2], isBool: false },
    { api: 'company_address', form: 'companyPostalCode', email: false, requiredWhen: [2, 3], isBool: false },
    { api: 'company_address', form: 'companyProvince', email: false, requiredWhen: [2, 3], isBool: false },
    { api: 'company_address', form: 'companyCountry', email: false, requiredWhen: [2, 3], isBool: false },
     */
  ] as const;

  cardCustomLabel: ITranslatableText = {
    translations: {
      en: "",
      fr: ""
    }
  };

  today: string = new Date().toISOString().split('T')[0];
  dateOfBirth: Date;

  customMessageData: ITranslatableText = {
    translations: {
      en: "",
      fr: ""
    }
  };

  customQuestionData: ICustomQuestions[];
  custFormatedQuestion: ICustomQuestions;

  customRegistrationCompleteRequest: IRegistrationCompletionRequest;

  personalAddress: IAddress;
  companyAddress: any;

  constructor(
    private fb : FormBuilder,
    private auth: AuthService,
    private loader: LoaderService,
    private alert: AlertService,
    public validators: ValidatorsService,
    private analytics: AnalyticsService,
    private account: AccountService,
    public translationService: TranslationService,
    private modalController: ModalController,
    public setting: SettingService
  ) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'randomCode' : ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'firstName' : ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'lastName' : ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'password' : ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'confirmPassword' : ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'acceptEmails': [true]
    });
    */
    this.form = this.fb.group({

      randomCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      firstName: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      lastName: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      confirmPassword: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      acceptEmails: this.fb.control(true)  // no validators
    });

    var buildCustomFormObject = this.buildCustomFormObject();

    this.customForm = this.fb.group(buildCustomFormObject);
    this.adjustValidation();

    
    /*
    this.form["patternReference"] = {
      randomCode: null,
      firstName: null,
      lastName: null,
      password: null,
      confirmPassword: null,
      acceptEmails: null
    };
    */
    this.patternReference = {
      randomCode: null,
      firstName: null,
      lastName: null,
      password: null,
      confirmPassword: null,
      acceptEmails: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);


    this.customForm.get("gender").setValue("M");
    if (this._locations.length > 0) {
      this.customForm.get('favoriteStore')?.setValue(this._locations[0].Id);
    }

    if(this.email) {
      this.customForm.get('email')?.setValue(this.email);
      this.customForm.get('email')?.disable();
      this.customForm.get('email')?.markAsTouched();
    }
    

    console.log(this._useCustomAPI);
    console.log(this.setting.configuration?.uIoptions?.useSMARegistration);

  }

  buildCustomFormObject() {
    const controls: Record<string, AbstractControl> = {};
    const config = this._CustomRegData?.config;

    //setting up custom labels:
    this.cardCustomLabel.translations['en'] = config.card_custom_label_en ? config.card_custom_label_en : '';
    this.cardCustomLabel.translations['fr'] = config.card_custom_label_fr ? config.card_custom_label_fr : '';

    for(var i = 0; i < this._CustomRegData?.custom_messages.length; i++) {
      var customMessage = this._CustomRegData?.custom_messages[i];
      if(customMessage.lang == "en") {
        this.customMessageData.translations["en"] = customMessage.message;
      } else if(customMessage.lang == "fr") {
        this.customMessageData.translations["fr"] = customMessage.message;
      }
    }

    for (const field of this.fieldMap) {
      let configValue = config?.[field.api] ?? 0;

      let fieldValidators = this.validators.formBuilderValidationInitializer(
        field.requiredWhen.includes(configValue),
        null,
        field.email ?? false
      );

      if (field.form === 'phone') {
        fieldValidators = Validators.compose([
          fieldValidators,
          this.phoneTenDigits()
        ]);
      }

      controls[field.form] = this.fb.control(
        field.isBool ? false : '',
        {
          validators: fieldValidators
        }
      );
    }

    // Password
    controls.password = this.fb.control('', {
      validators: this.validators.formBuilderValidationInitializer(
        true,
        null,
        null,
        null,
        [],
        8
      )
    });

    // Password confirmation
    controls.passwordConfirmation = this.fb.control('', {
      validators: this.validators.formBuilderValidationInitializer(
        true,
        null,
        null,
        null,
        [],
        8
      )
    });

    controls.dateOfBirth = this.fb.control('');
    controls.acceptEmails = this.fb.control(true);
    controls.geolocation = this.fb.control(true);

    controls.validationCode = this.fb.control('', {
      validators: this.validators.formBuilderValidationInitializer(
        true,
        null,
        null
      )
    });

    /*
    if(this._CustomRegData?.custom_questions.length > 0) {
      for(var y = 0; y < this._CustomRegData?.custom_questions.length; y++) {
        var custQuestion = this._CustomRegData?.custom_questions[y];

        
        this.custFormatedQuestion.id = custQuestion.id;
        this.custFormatedQuestion.mandatory = custQuestion.mandatory;
        this.custFormatedQuestion.pageId = custQuestion.page_id;
        this.custFormatedQuestion.questionTranslation.translations = custQuestion.id;
        this.customQuestionData
      }
      
    } else {
      this.customQuestionData = [];
    }
    */

    controls.customQuestions = this.fb.array(
      (this._CustomRegData?.custom_questions ?? []).map(question =>
        this.fb.group({
          questionId: [question.id],
          answerId: this.fb.control(question.custom_answers?.[0]?.id ?? null, {
            validators: this.validators.formBuilderValidationInitializer(
              question.mandatory === 2,
              null,
              false
            )
          })
        })
      )
    );

    console.log(controls);
    return controls;
  }

  getTranslation(question?: any, answer?: any): string {
    const lang = this.translationService.getLanguage();

    if (question?.custom_question_langs?.length) {
      return (
        question.custom_question_langs.find(q => q.lang === lang)?.question ?? ''
      );
    }

    if (answer?.custom_answer_langs?.length) {
      return (
        answer.custom_answer_langs.find(a => a.lang === lang)?.answer ?? ''
      );
    }

    return '';
  }

  /*
  buildCustomFormObject() {

    this._CustomRegData?.config
    let controls = {};

    let control = {};

    ////////////////////////////////////////////////////////////////

    if(this._CustomRegData?.config?.question_2 == 0) {
      control = {
        question2: this.fb.control(''),
      }
    } else if(this._CustomRegData?.config?.question_2 > 1) {
      control = {
        question2: this.fb.control('', {
          validators: this.validators.formBuilderValidationInitializer(true, null, null)
        }),
      }
    }

    controls = {
      ...controls,
      ...control
    };
    control = {};
    ////////////////////////////////////////////////////////////////

    
    console.log(controls);
    return controls;
  }
  */

  adjustValidation() {
    const cardNumber = this.customForm.get('cardNumber');
    const digitalCard = this.customForm.get('digitalCard');

    digitalCard?.valueChanges.subscribe((isDigital: boolean) => {
      if (isDigital) {
        cardNumber?.setValue('');
        cardNumber?.clearValidators();
      } else {
        cardNumber?.setValidators(
          this.validators.formBuilderValidationInitializer(
            this._CustomRegData?.config?.force_card_number || this._CustomRegData?.config?.card_number > 1,
            null,
            false
          )
        );
      }

      cardNumber?.updateValueAndValidity();
    });
  }

  async getAddress() {
    const modal = await this.modalController.create({
      component: AddressEditorModalComponent,
      componentProps: {
        title: 'Store.Address',
        skipProvinceValidation: true
      }
    });

    modal.onWillDismiss()
      .then((result: any) => {
        if(!result || !result.data) return;
        this.personalAddress = result.data;

        this.customForm.get('postalCode').setValue(this.personalAddress?.postalCode);
        this.customForm.get('province').setValue(this.personalAddress?.province);
        this.customForm.get('street').setValue(this.personalAddress?.street);
        this.customForm.get('streetDirection').setValue(this.personalAddress?.streetDirection);
        this.customForm.get('streetNumber').setValue(this.personalAddress?.streetNumber);
        this.customForm.get('streetType').setValue(this.personalAddress?.streetType);
        this.customForm.get('suiteNumber').setValue(this.personalAddress?.suiteNumber);
        this.customForm.get('city').setValue(this.personalAddress?.city);


        // cleares the validation (not provided by our address system)
        this.customForm.get('country')?.clearValidators();
        this.customForm.get('country')?.updateValueAndValidity();

        // cleares the validation (not provided by our address system)
        this.customForm.get('suffix')?.clearValidators();
        this.customForm.get('suffix')?.updateValueAndValidity();
      });

    await modal.present();
  }

  async submit() {

    if(!this._useCustomAPI || !this.setting.configuration?.uIoptions?.useSMARegistration) {
      //sanitizing
      this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

      if (!this.form.valid)
        return;

      this.formErrors.clear();

      const loader = await this.loader.create();
      await loader.present();
      this.auth.register({
        AcceptEmails: this.form.get('acceptEmails').value,
        Id: this.emailCode.codeId,
        Password: this.form.get('password').value,
        ConfirmPassword: this.form.get('confirmPassword').value,
        FirstName: this.form.get('firstName').value,
        LastName: this.form.get('lastName').value,
        RandomCode: this.form.get('randomCode').value,
      })
        .pipe(finalize(() => {
          loader.dismiss();
        }))
        .subscribe(result => {

          ////////////////////////////////////////////
          // this only happens if there's a member card added during registration
          if(this._emailCode.memberCard != null) {
            this.account.addExistingCard(this._emailCode.memberCard)
              .subscribe((model) => {

              });
          }
          ////////////////////////////////////////////

          this.onSubmit.emit();
          this.analytics.conversionUpdate("signUp");
        },
        (error: HttpErrorResponse) => {
          if (error.status == 500)
            this.alert.showUnexpectedErrorMsg();
          else {
            const modelState = error.error.ModelState;

            if (!modelState) 
              return;

            for (let key in modelState) {
              let property = HttpHelpers.removePrefix(key, 'model.');
              property = property.charAt(0).toLowerCase() + property.slice(1);
              this.formErrors.set(property, modelState[key][0]);
            }
          }
        });
    } else {
      this.formErrors.clear();
      // this is returning the value to an API for the custom registration

      // for card number, make it empty if the digital card is true (cannot have a digital card true + card_number field with data)

  

      //const loader = await this.loader.create();
      //await loader.present();

      //console.log(this.personalAddress); 

      let pageId = this.setting.getSmaPageId();
      //console.log(pageId);
      //console.log(this.setting.configuration.externalProviderId);

      this.customRegistrationCompleteRequest = {
        pageId: Number(pageId), //autofill before API sent
        externalProviderId: Number(this.setting.configuration.externalProviderId), //autofill before API sent
        password: this.customForm.get("password").value,
        confirm_password: this.customForm.get("passwordConfirmation").value,
        first_name: this.customForm.get("firstName").value,
        last_name: this.customForm.get("lastName").value,
        email: this.customForm.get("email").value,
        mobile: null,
        phone: (this.customForm.get("phone")?.value || '').replace(/\D/g, ''),
        company_phone: null, //this.customForm.get("companyPhone").value,
        company_title: null, //this.customForm.get("companyTitle").value,
        card_number: this.customForm.get("cardNumber").value,
        digital_card: this.customForm.get("digitalCard").value,
        gender: this.customForm.get("gender").value,
        mobile_carrier: null,
        question_1: null,
        question_2: null,
        favorite_store: this.customForm.get("favoriteStore").value,
        address: {
          street_number: this.personalAddress?.streetNumber ? this.personalAddress.streetNumber.toString() : null,
          suffix: null,
          street: this.personalAddress?.street || null,
          street_type: this.personalAddress?.streetType || null,
          street_direction: this.personalAddress?.streetDirection || null,
          suite_number: this.personalAddress?.suiteNumber || null,
          city: this.personalAddress?.city || null,
          postal_code: this.personalAddress?.postalCode || null,
          province: this.personalAddress?.province || null,
          country: null
        },
        company_address: {
          street_number: null,
          suffix: null,
          street: null,
          street_type: null,
          street_direction: null,
          suite_number: null,
          city: null,
          postal_code: null,
          province: null,
          country: null
        },
        send_email: this.customForm.get("acceptEmails").value,
        //date_of_birth: this.customForm.get("dateOfBirth").value,
        date_of_birth: this.customForm.get("dateOfBirth").value ? `${this.customForm.get("dateOfBirth").value} 00:00:00` : null ,
        geolocation: this.customForm.get("geolocation").value,
        language: this.translationService.getLanguage(),
        validation_code: this.customForm.get("validationCode").value, // will add it shortly
        custom_question_answers: this.customForm.get("customQuestions").value
      }


      //console.log(this.customRegistrationCompleteRequest);

      this.auth.completeCustomRegistration(this.customRegistrationCompleteRequest)
        .pipe(finalize(() => {
          //loader.dismiss();
        }))
        .subscribe(result => {
          // if successful, simply login
          if(result.success){
            this.onSubmit.emit();
            this.analytics.conversionUpdate("signUp");
          } else {
            if(result.message){
              this.alert.showMessage(result.message);
            }
            if(result.errors.length > 0){
              for (let error of result.errors) {
                this.formErrors.set(error.name, error.message);
              }
            }
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status == 500)
            this.alert.showUnexpectedErrorMsg();
          else {
            const modelState = error.error.ModelState;

            if (!modelState) 
              return;

            for (let key in modelState) {
              let property = HttpHelpers.removePrefix(key, 'model.');
              property = property.charAt(0).toLowerCase() + property.slice(1);
              this.formErrors.set(property, modelState[key][0]);
            }
          }
        });

      
    }
    
  }

  formatPhone(event: any): void {
    const input = event.target;

    // Keep only digits
    let digits = input.value.replace(/\D/g, '').substring(0, 10);

    // Format for display
    let formatted = '';

    if (digits.length > 0) {
      formatted = '(' + digits.substring(0, 3);
    }

    if (digits.length >= 4) {
      formatted += ') ' + digits.substring(3, 6);
    }

    if (digits.length >= 7) {
      formatted += '-' + digits.substring(6, 10);
    }

    // Show formatted value
    input.value = formatted;

    // Store only digits in the FormControl
    this.form.patchValue(
      { phone: digits },
      { emitEvent: false }
    );
  }

  filterName(event: any): void {
    const input = event.target;

    // Allow letters, spaces, apostrophes and hyphens
    input.value = input.value.replace(/[^a-zA-ZÀ-ÿ' -]/g, '');
  }

  formatCardNumber(event: Event): void {
    const input = event.target as HTMLInputElement;

    const cursorPosition = input.selectionStart ?? input.value.length;

    // Count digits before the cursor
    const digitsBeforeCursor = input.value
      .slice(0, cursorPosition)
      .replace(/\D/g, '')
      .length;

    // Raw 16-digit value
    const value = input.value
      .replace(/\D/g, '')
      .substring(0, 16);

    // Format into groups of 4
    const formatted = value.replace(/(\d{4})(?=\d)/g, '$1 ');

    input.value = formatted;

    // Keep raw value in the FormControl
    this.customForm.get('cardNumber')?.setValue(value, {
      emitEvent: false
    });

    // Restore cursor position
    let newCursorPosition = digitsBeforeCursor;

    if (digitsBeforeCursor > 0) {
      newCursorPosition += Math.floor(digitsBeforeCursor / 4);
    }

    newCursorPosition = Math.min(newCursorPosition, formatted.length);

    requestAnimationFrame(() => {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    });
  }

  onCardNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Keep digits only and limit to 16
    const value = input.value
      .replace(/\D/g, '')
      .substring(0, 16);

    // While typing, show only the numbers
    input.value = value;

    // FormControl always stores the raw number
    this.customForm.get('cardNumber')?.setValue(value, {
      emitEvent: false
    });
  }

  formatCardNumberOnBlur(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Get the raw number from the FormControl
    const value = this.customForm.get('cardNumber')?.value
      ?.toString()
      .replace(/\D/g, '')
      .substring(0, 16) ?? '';

    // Format into groups of 4
    input.value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
  }

  unformatCardNumberOnFocus(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Remove spaces when the user starts editing again
    input.value = input.value.replace(/\D/g, '');
  }

  phoneTenDigits(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const digits = control.value.replace(/\D/g, '');

      return digits.length === 10
        ? null
        : { phoneLength: true };
    };
  }
}
